module.exports = __webpack_public_path__ + "static/img/simple-circle_gray.62b22ffa.svg";